module.exports = __webpack_public_path__ + "media/images/ohap_announcement_on-caedc76bf35ac6ba9db90f33135ac940.png";